import globalStyle from '@/styles/Global.scss';
import React, {useEffect, useRef, useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory, useParams} from "react-router";
import ImageCard from "@/components/ImageCard";
import QRCode from "qrcode";
import {getCard} from "@/api/card";
import {Card} from "@/entity/Card";
import MButton from "@/components/atom/MButton";
import {PaygentForm} from "@/components/PaygentForm";
import style from './Watashi.scss';

const [webEndPoint] = [process.env.REACT_APP_WEB_ENDPOINT]

const WatashiQR = () => {
  const history = useHistory()
  const {id} = useParams()
  const [card, setCard] = useState(new Card({}))
  // const [canMoreExchange, setCanMoreExchange] = useState(false)
  const canvasRef = useRef(null);
  const publicCanvasRef = useRef(null);

  useEffect(() => {
    (async () => {
      const card = await getCard({id})
      setCard(card)
    })()
  }, [id])

  // Exchange QR (for trading)
  useEffect(() => {
    if (canvasRef.current === null) {
      return
    }
    const watashiURL = `${webEndPoint}/uketori/${id}/kdjfiadfeeoja`
    QRCode.toCanvas(canvasRef.current, watashiURL, function (error) {
      if (error) console.error(error)
      console.log('success!');
    })
  }, [canvasRef, id, card])

  // Public QR (for showcase) when the card is public
  useEffect(() => {
    if (!card.isPublic) return
    if (publicCanvasRef.current === null) return
    const publicURL = `${webEndPoint}/showcase/${id}`
    QRCode.toCanvas(publicCanvasRef.current, publicURL, function (error) {
      if (error) console.error(error)
    })
  }, [publicCanvasRef, id, card])

  const toBack = () => {
    history.push(`/watashi/${id}`)
  }

  return (
    <>
      <Layout category={'WA'}>
        <div className={globalStyle.container}>
          <div className={globalStyle.bodyContainer}>
            <div className={globalStyle.body}>
              <div className={globalStyle.centerPanel}>
                <ImageCard id={id}></ImageCard>
                <h3>{card.name}</h3>
                <span>交換用QR</span>
                <div className={ card.canExchange ? style.showQR : style.noShowQR }>
                  <canvas ref={canvasRef}></canvas>
                </div>
                {
                  !card.canExchange &&
                  <>
                    <div>ご購入情報がないため、名刺交換用のQRコードはご利用いただけません。</div>
                    <div>
                      <div>交換用のQRのご購入は以下のボタンをタップしてください。</div>
                      <div>金額：550円(税込)</div>
                      <PaygentForm price={550} cardId={card.id} item={'qr'} />
                      <div>支払いはペイジェント社のページに移動します。</div>
                    </div>
                  </>
                }
                {
                  card.isPublic && (
                    <>
                      <div style={{ marginTop: '16px' }}>
                        <span>公開用QR</span>
                        <div className={style.showQR}>
                          <canvas ref={publicCanvasRef}></canvas>
                        </div>
                      </div>
                    </>
                  )
                }
              </div>
            </div>
          </div>
          <div className={globalStyle.footerContainer}>
            <div className={globalStyle.footer}>
              <div className={globalStyle.centerPanel}>
                <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default WatashiQR
